import type pino from 'pino';

import type {LoggerTelemetryBridge} from '../../otel/types';

const noopBridge: LoggerTelemetryBridge = {
  forwardLog: () => undefined,
  getFields: () => ({}),
};

let loggerTelemetryBridge: LoggerTelemetryBridge = noopBridge;

export const setLoggerTelemetryBridge = (
  bridge: Partial<LoggerTelemetryBridge> | null,
): void => {
  loggerTelemetryBridge = {
    ...noopBridge,
    ...bridge,
  };
};

export const forwardLoggerTelemetry = (
  args: Parameters<pino.LogFn>,
  level: number,
): void => {
  loggerTelemetryBridge.forwardLog(args, level);
};

export const getLoggerTelemetryFields = (): Record<string, unknown> => {
  return loggerTelemetryBridge.getFields();
};
